export default __webpack_public_path__ + "static/media/peacock-trans.f88aba5e.png";